export default {
    entityKey: 'testing-personas',
    basePath: '/testing-personas',
    titles: {
        singular: 'Persona',
        plural: 'Personas'
    }
}
